<div class="hrclosure-card">
  <h2>HR Closure</h2>
  <h4>HR Department</h4>
  
  <table class="review-table">
    <tr>
      <td><strong>Employee ID:</strong></td>
      <td>{{ checkerData.employeeId }}</td>
    </tr>
    <tr>
      <td><strong>Name:</strong></td>
      <td>{{ checkerData.fullname }}</td>
    </tr>
   <tr>
      <td><strong>Designation:</strong></td>
      <td>{{ checkerData.designation }}</td>
    </tr>
    <tr>
      <td><strong>Location:</strong></td>
      <td>{{ checkerData.grade }}</td>
    </tr>
    <tr>
      <td><strong>Date of Joining:</strong></td>
      <td>{{ checkerData.dateOfJoining }}</td>
    </tr>
    <tr>
      <td><strong>Plant:</strong></td>
      <td>{{ checkerData.plant }}</td>
    </tr>
    <tr>
      <td><strong>Department:</strong></td>
      <td>{{ checkerData.department }}</td>
    </tr>
    <tr *ngIf="checkerData.OD_Account_type=='Role Change'">
      <tr>
      <td><strong>Further Department:</strong></td>
      <td>{{ checkerData.Furtherdepartment }}</td>
    </tr>
    <tr>
      <td><strong>Requester:</strong></td>
      <td>{{ checkerData.requester }}</td>
    </tr>
    <tr>
      <td><strong>Checker :</strong></td>
      <td>{{ checkerData.checker }}</td>
    </tr>
    <tr>
      <td><strong>Approver :</strong></td>
      <td>{{ checkerData.final }}</td>
    </tr>
    <tr>
      <td><strong>AD UserName:</strong></td>
      <td>{{ checkerData.OD_ITAD_AccountName }}</td>
    </tr>
    <tr>
      <td><strong>Mail Id:</strong></td>
      <td>{{ checkerData.Mailid }}</td>
    </tr>
  </table>

  <div class="form-row">
    <button type="submit" class="btn btn-submit" (click)="onHrSubmit()" >Submit</button>
    <!-- <button type="submit" class="btn btn-reject" (click)="onHrSubmit()" >Reject</button> -->
  </div>
</div>
